import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Check } from "lucide-react";

export const PerksCard = () => {
  return (
    // Kartı şeffaf koyu yaptık ve beyaz yazı ekledik
    <Card className="lg:col-span-1 bg-slate-900/40 border-white/10 backdrop-blur-sm text-white h-full">
      <CardHeader>
        <CardTitle className="text-white text-2xl">Mentorluk Programı Avantajları</CardTitle>
        <CardDescription className="text-slate-300">Size özel hazırlanmış program içeriği</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          {[
            {
              title: "Birebir Mentorluk",
              desc: "Deneyimli mentörünüzle haftalık birebir görüşmeler"
            },
            {
              title: "Kişiselleştirilmiş Çalışma Planı",
              desc: "Size özel hazırlanmış günlük ve haftalık çalışma programı"
            },
            {
              title: "Sürekli İletişim",
              desc: "WhatsApp üzerinden 7/24 soru sorma imkanı"
            },
            {
              title: "Motivasyon Desteği",
              desc: "Sürekli motivasyon ve hedef odaklı rehberlik"
            },
            {
              title: "Deneyim Aktarımı",
              desc: "Başarılı bir öğrencinin tecrübelerinden faydalanma"
            },
            {
              title: "Üniversite Hazırlık",
              desc: "Üniversite hayatına adaptasyon için özel tavsiyeler"
            }
          ].map((perk, index) => (
            <div key={index} className="flex items-start gap-4 group">
              {/* İkon Konteynırı - Indigo tonunda */}
              <div className="flex-shrink-0 h-7 w-7 rounded-lg bg-[#4F46E5]/20 border border-[#4F46E5]/30 flex items-center justify-center text-white shadow-lg shadow-[#4F46E5]/10 group-hover:bg-[#4F46E5] transition-colors duration-300">
                <Check className="h-4 w-4" />
              </div>

              <div className="space-y-1">
                <h4 className="font-bold text-white text-lg leading-none">{perk.title}</h4>
                <p className="text-sm text-slate-400 leading-relaxed">{perk.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};